/**
 * Centralized translations for DMS module
 * Contains all labels used across DMS components
 */

export const dmsLabels = {
    it: {
        // dms_file_edit.js
        saveData: `Salva questi dati`,

        // dms_scraper_screen.js
        stillThere: `Sei ancora qui?`,
        stillThereQuestion: `Hey? Sei ancora qui? Clicca il tasto ok o chiuderò la connessione...`,
        connectingToApi: `Connettendomi all'AI Scraper`,
        connected: `Connesso`,
        pageUrl: `Url della pagina`,
        urlScraped: `Inserisci l'url della pagina che deve essere analizzata`,
        followPage: `Segui i link della pagina per effetuare lo scrape del sito web`,
        readyToScrape: `Pronto per effettuare lo scrape del sito`,
        start: `Inizia`,
        stop: `Ferma`,

        // chat_screen.js
        like: `Mi piace`,
        dislike: `Non mi piace`,
        regenerates: `Rigenera`,
        share: `Condividi`,
        docxDownload: 'Download in DOCX',
        documentsExport: `Esporta in Documenti`,
        options: `Opzioni`,
        edit: `Modifica`,
        delete: `Elimina`,
        download: `Conferma download`,
        downloadDocumentQuestion: `Vuoi scaricare questa risposta come documento?`,
        cancelButtonText: `Annulla`,
        downloading: `Download in corso`,
        waiting: `Attendere prego...`,
        downloadCompleted: `Download completato`,
        successDownload: `Il documento è stato scaricato con successo`,
        close: `Chiudi`,
        error: `Errore`,
        downloadError: `Si è verificato un errore durante il download: {{errorMessage}}`,
        export: `Conferma esportazione`,
        exportQuestion: `Vuoi esportare questa risposta nei documenti?`,
        exportButton: `Esporta`,
        exporting: `Esportazione in corso...`,
        exportCompleted: `Export completato`,
        exportQuestionModify: `Puoi trovare il file nella sezione dms/Documents/exports. Vuoi modificare il documento ora?`,
        modifyDocument: `Modifica documento`,
        cancelButtonTextTy: `No, grazie`,
        exportDocument: `Puoi trovare il file nella sezione dms/Documents/exports`,
        exportError: `Si è verificato un errore durante l'esportazione`,
        chatWithAi: `Parla con l'AI`,
        aIProfile: `Seleziona il profilo dell'AI`,
        grounding: `Scegli il Grounding`,
        nop: `No`,
        askMe: `Chiedimi`,
        submit: `Invia`,
        loading: `Caricamento`,
        tagFiles: `Files contrassegnati`,
        noFiles: `Nessun file trovato`,

        // dms_screen.js
        moveElement: `Sposta l'elemento`,
        move: `Sposta`,
        info: `Info`,
        chat: `Chat`,
        download: `Scarica`,
        makeGrounding: `Crea grounding`,
        unmakeGrounding: `Rimuovi grounding`,
        analyzeInvoice: `Analizza fattura`,
        createFolder: `Crea cartella`,
        uploadDocument: `Carica documento`,
        folderName: `Nome cartella`,
        insertFolderName: `Inserisci il nome della cartella`,
        save: `Salva`,
        folderUpdatedSuccessfully: `Cartella aggiornata con successo`,
        name: `Nome`,
        fileType: `Tipo file`,
        size: `Dimensione`,
        lastUpdate: `Ultimo aggiornamento`,
        creator: `Creatore`,
        Status: `Status`,
        commands: `Comandi`,
        filesList: `Lista file`,
        fileUpdatedSuccessfully: `File aggiornato con successo`,
        updateFolderError: `Errore nell'aggiornamento della cartella`,
        search: `Cerca`,
        semanticSearch: `Ricerca semantica`,
        bytes: `bytes`,
        wwwScraper: `WWW Scraper`,
        aiPoweredScraper: `Web scraper alimentato da AI`,
        dropFilesToUpload: `Trascina i file qui per caricarli in`,
        createdAt: `Creato il`,
        lastUpdatedBy: `Ultimo aggiornamento da`,
        authors: `Autori`,
        subject: `Oggetto`,
        summary: `Riassunto`,
        topics: `Argomenti`,
        fileName: `Nome file`,
        cancel: `Annulla`,
        submit: `Invia`,
        itemPermission: `Permessi`,
        permissionModalHeader: `Autorizza utenti e/o gruppi`,
        addToPermission: 'Aggiungi',
        addUserGroup: 'Aggiungi permessi ad  utenti e/o gruppi',
        searchUserGroup: `Cerca utenti o gruppi`,
        addSelected: 'Salva',
        userGroup: `Utente/Gruppo`,
        success: `Successo`,
        permissionsSaved: `Permessi salvati con successo`,
        permissionsSaveError: `Errore nel salvataggio dei permessi`,
        permissionParagraph: `Cerca un utente o gruppo al quale dare i diritti`,
        expirationDate: `Data di fine validità `,
        dmsCategory: `Categoria del file`,
        keywords: `Parole chiave`,
        itemUpdatedSuccessfully: 'Dati aggiornati con successo',
        dms: 'DMS',
        advancedOptions:'Opzioni avanzate',
        aiChatEditor:'Editor AI',
        keywords: 'Parole chiave',
        keywordsPlaceholder: `Inserisci una nuova parola chiave e premi Enter`,
        // Advanced filters
        advancedFilters: 'Filtri avanzati',
        resetFilters: 'Resetta filtri',
        applyFilters: 'Applica filtri',
        filterError: 'Errore nell\'applicazione dei filtri',
        classification: 'Classificazione',
        status: 'Stato',
        AdvancedSearch: 'Ricerca avanzata',
        
        // Pagination
        showing: 'Mostrando',
        of: 'di',
        items: 'elementi',
        previous: 'Precedente',
        next: 'Successivo',
        loading: 'Caricamento',

        // status_buttons.js
        statusDraft: 'Bozza',
        statusPendingValidation: 'In attesa di validazione',
        statusValidatedPendingApproval: 'Validato (in attesa di approvazione)',
        statusAccepted: 'Accettato',
        statusUnknown: 'Sconosciuto',
        submitForValidation: 'Invia per la validazione',
        validationPending: 'Validazione in attesa',
        validated: 'Validato',
        active: 'Attivo',
        undoValidation: 'Annulla validazione',
        reject: 'Rifiuta',
        validate: 'Valida',
        approve: 'Approva',
        updateStatusError: 'Aggiornamento dello stato non riuscito',

        // edit_panel.js
        fileInfo: 'Informazioni file',
        downloadHistory: 'Cronologia download',
        status: 'Stato',
        linkedFiles: 'File allegati',
        filesLinkedToThis: 'File collegati a partire da questo documento',
        filesLinkedFromThis: 'File collegati con questo documento',
        noFilesLinkedToThis: 'Nessun file collegato a questo',
        noFilesLinkedFromThis: 'Nessun file collegato da questo',
        addNewLinkedFile: 'Aggiungi nuovo file',
        addNewLinkedFileDescription: 'Aggiungi un nuovo file collegato',
        linkedFilesAdded: 'File collegati aggiunti con successo',
        linkedFilesAddError: 'Errore durante l\'aggiunta dei file collegati',
        removeLinkedFile: 'Rimuovi file collegato',
        removeLinkedFileConfirm: 'Sei sicuro di voler rimuovere il collegamento al file "{fileName}"?',
        linkedFileRemoved: 'File collegato rimosso con successo',
        linkedFileRemoveError: 'Errore durante la rimozione del file collegato',
        yes: 'Sì',
        no: 'No',
        actions: 'Azioni',
        // file_info.js
        save: 'Salva',
        organizations: 'Organization',
        businessUnit: 'Business Unit',
        noStatusHistory: 'Nessuna cronologia stati',
        noDownloadHistory: 'Nessuna cronologia download',

        // status_tab.js
        user: 'Utente',
        date: 'Data',
        fromStatus: 'Da stato',
        toStatus: 'A stato',

        // download_history.js
        username: 'Nome utente',
        userEmail: 'Email utente',
        date: 'Data',

    },

    en: {
        // dms_file_edit.js
        saveData: `Save this data`,

        // dms_scraper_screen.js
        stillThere: `Still there?`,
        stillThereQuestion: `Hey? Are you still there? Please tap OK button otherwise I'll close the connection...`,
        connectingToApi: `Connecting to AI Scraper engine`,
        connected: `Connected`,
        pageUrl: `Page url`,
        urlScraped: `Insert the url of the page to be scraped.`,
        followPage: `Follow page links and scrape the entire web site`,
        readyToScrape: `Ready to scrape a web site`,
        start: `Start`,
        stop: `Stop`,

        // chat_screen.js
        like: `Like`,
        dislike: `Dislike`,
        regenerates: `regenerates`,
        share: `Share`,
        docxDownload: 'Download in DOCX',
        documentsExport: `Exports in Documents`,
        options: `Options`,
        edit: `Edit`,
        delete: `Delete`,
        download: `Confirm download`,
        downloadDocumentQuestion: `Do you want to download the anwser as document?`,
        cancelButtonText: `Cancel`,
        downloading: `Downloading`,
        waiting: `Please wait...`,
        downloadCompleted: `Download completed`,
        successDownload: `Document successfully downloaded`,
        close: `Close`,
        error: `Error`,
        downloadError: `An error occurred while downloading: {{errorMessage}}`,
        export: `Confirm export`,
        exportQuestion: `Do you want to export this answer in Documents?`,
        exportButton: `Export`,
        exporting: `Exporting...`,
        exportCompleted: `Export completed`,
        exportQuestionModify: `You can find the file in the dms/Documents/exports section. Do you want to edit the document now?`,
        modifyDocument: `Modify document`,
        cancelButtonTextTy: `No, thank you`,
        exportDocument: `You can find the file in the dms/Documents/exports section.`,
        exportError: `An error occurred while exporting`,
        chatWithAi: `Chat with AI`,
        aIProfile: `Choose the Ai Profile`,
        grounding: `Choose the Grounding`,
        nop: `Nop`,
        askMe: `Ask me`,
        submit: `Submit`,
        loading: `Loading`,
        tagFiles: `Tag Files`,
        noFiles: `No files found`,

        // dms_screen.js
        addToPermission: 'New',
        permissionModalHeader: `Grant permission to user or groups`,
        moveElement: `Move the element`,
        move: `Move`,
        info: `Info`,
        chat: `Chat`,
        download: `Download`,
        makeGrounding: `Make grounding`,
        unmakeGrounding: `Unmake grounding`,
        analyzeInvoice: `Analyze Invoice`,
        createFolder: `Create folder`,
        uploadDocument: `Upload document`,
        folderName: `Folder name`,
        insertFolderName: `Insert name for the folder`,
        save: `Save`,
        name: `Name`,
        size: `Size`,
        fileType: `File type`,
        lastUpdate: `Last update`,
        fileUpdatedSuccessfully: `File updated successfully`,
        creator: `Creator`,
        Status: `Status`,
        commands: `Commands`,
        filesList: `Files list`,
        search: `Search`,
        semanticSearch: `Semantic Search`,
        bytes: `bytes`,
        wwwScraper: `WWW Scraper`,
        aiPoweredScraper: `AI powered world wide web scraper`,
        dropFilesToUpload: `Drop files to upload them to`,
        folderUpdatedSuccessfully: `Folder updated successfully`,
        updateFolderError: `Error updating folder`,
        keywords: `Keywords`,
        createdAt: `Created at`,
        lastUpdatedBy: `Last updated by`,
        authors: `Authors`,
        subject: `Subject`,
        summary: `Summary`,
        topics: `Topics`,
        fileName: `File Name`,
        cancel: `Cancel`,
        submit: `Submit`,
        itemPermission: `Permissions`,
        addUserGroup: 'Grant permission to group or users',
        searchUserGroup: `Search user or groups`,
        addSelected: 'Save',
        userGroup: `User/Group`,
        success: `Success`,
        permissionsSaved: `Permissions saved successfully`,
        permissionsSaveError: `Error saving permissions`,
        permissionParagraph: `Find user or groups and give the permissions`,
        expirationDate: `Expiration Date `,
        classification: `Classification`,
        dmsCategory: `File categories`,
        keywords: `Keywords`,
        keywordsPlaceholder: `Type new keyword and press Enter`,
        itemUpdatedSuccessfully: 'Data saves succesfully',
        advancedOptions: 'Advanced Options',
        dms: 'DMS',
        aiChatEditor:'Editor AI',
        AdvancedSearch: 'Advanced search',
        // Advanced filters
        advancedFilters: 'Advanced filters',
        resetFilters: 'Reset filters',
        applyFilters: 'Apply filters',
        filterError: 'Error applying filters',
        status: 'Status',
        
        // Pagination
        showing: 'Showing',
        of: 'of',
        items: 'items',
        previous: 'Previous',
        next: 'Next',
        loading: 'Loading',

        // status_buttons.js
        statusDraft: 'Draft',
        statusPendingValidation: 'Pending validation',
        statusValidatedPendingApproval: 'Validated (pending approval)',
        statusAccepted: 'Accepted',
        statusUnknown: 'Unknown',
        submitForValidation: 'Submit for validation',
        validationPending: 'Validation pending',
        validated: 'Validated',
        active: 'Active',
        undoValidation: 'Undo validation',
        reject: 'Reject',
        validate: 'Validate',
        approve: 'Approve',
        updateStatusError: 'Failed to update status',

        // edit_panel.js
        fileInfo: 'File info',
        downloadHistory: 'Download history',
        status: 'Status',
        linkedFiles: 'Linked Files',
        filesLinkedToThis: 'Files Linked To This',
        filesLinkedFromThis: 'Files Linked From This',
        noFilesLinkedToThis: 'No files linked to this',
        noFilesLinkedFromThis: 'No files linked from this',
        addNewLinkedFile: 'Add New File',
        addNewLinkedFileDescription: 'Add a new linked file',
        linkedFilesAdded: 'Linked files added successfully',
        linkedFilesAddError: 'Error adding linked files',
        removeLinkedFile: 'Remove Linked File',
        removeLinkedFileConfirm: 'Are you sure you want to remove the link to "{fileName}"?',
        linkedFileRemoved: 'Linked file removed successfully',
        linkedFileRemoveError: 'Error removing linked file',
        yes: 'Yes',
        no: 'No',
        actions: 'Actions',

        // file_info.js
        save: 'Save',
        organizations: 'Organization',
        businessUnit: 'Business Unit',
        noStatusHistory: 'No status history',
        noDownloadHistory: 'No download history',

        // status_tab.js
        user: 'User',
        date: 'Date',
        fromStatus: 'From Status',
        toStatus: 'To Status',

        // download_history.js
        username: 'Username',
        userEmail: 'User Email',
        date: 'Date',
    }
}; 